import styled from 'styled-components';

export const Icon = styled.div`
  svg {
    display: block;
    width: 35px;
    fill: hsl(0, 0%, 51%);
  }
`;
